/**
 *
 *测试中经社三期路由  各公司 需参照此路由独立创建自己的路由模块
 *
 */

const v3Router = [
  {
    path: "/brand",
    name: "brand",
    component: () =>
      import(/* webpackChunkName: "censThree" */ "@/views/censThreePage"),
    redirect: "/brand/BigFrame",

    children: [
      {
        path: "BigFrame",
        name: "BigFrame",
        component: () =>
          import(
            /* webpackChunkName: "BigFrame" */ "@/views/censThreePage/BigFrame"
          ),
        meta: {
          auth: true,
        },
        children: [
          {
            path: "logoDetail",
            name: "logoDetail",
            component: () =>
              import(
                /* webpackChunkName: "logoDetail" */ "@/views/censThreePage/logoDetail"
              ),
            meta: {
              auth: true,
            },

            children: [
              {
                path: "ArticleDetails", //logo 列表 对应的内容
                name: "ArticleDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "ArticleDetails" */ "@/views/censThreePage/logoDetail/components/ArticleDetails"
                  ),
                meta: {
                  auth: true,
                },
              },
              {
                path: "MArticleDetail",
                name: "MArticleDetail",
                component: () =>
                  import(
                    /* webpackChunkName: "MArticleDetails" */ "@/views/censThreePage/logoDetail/components/MArticleDetail"
                  ),
                meta: {
                  auth: true,
                },
              },
              {
                path: "CArticleDetail", //点击more 对应的详情
                name: "CArticleDetail",
                component: () =>
                  import(
                    /* webpackChunkName: "CArticleDetail" */ "@/views/censThreePage/logoDetail/components/CArticleDetail"
                  ),
                meta: {
                  auth: true,
                },
              },
              {
                path: "NewsDetail",
                name: "NewsDetail",
                component: () => import(/* webpackChunkName: "NewsDetail" */ "@/views/censThreePage/logoDetail/components/NewsDetail"),
                meta: {
                  parentName: "NewsCensus"
                }
              },
              {
                path: "Detail",
                name: "Detail",
                component: () =>
                  import(
                    /* webpackChunkName: "Detail" */ "@/views/censThreePage/logoDetail/Detail"
                  ),
                meta: {
                  auth: true,
                },
                children: [
                  {
                    path: "CompanyIntroduction",
                    name: "CompanyIntroduction",
                    component: () =>
                      import(
                        /* webpackChunkName: "CompanyIntroduction" */ "@/views/censThreePage/logoDetail/components/CompanyIntroduction"
                      ),
                    meta: {
                      auth: true,
                      per: "CompanyIntroduction",
                    },
                  },
                  {
                    path: "OverseasEnthusiasm",
                    name: "OverseasEnthusiasm",
                    component: () =>
                      import(
                        /* webpackChunkName: "OverseasEnthusiasm" */ "@/views/censThreePage/logoDetail/components/OverseasEnthusiasm"
                      ),
                    meta: {
                      auth: true,
                      per: "OverseasEnthusiasm",
                    },
                  },
                  {
                    path: "LyricSearch",
                    name: "LyricSearch",
                    component: () =>
                      import(
                        /* webpackChunkName: "LyricSearch" */ "@/views/censThreePage/logoDetail/components/LyricSearch"
                      ),
                    meta: {
                      auth: true,
                      per: "LyricSearch",
                    },
                  },
                  {
                    path: "User",
                    name: "User",
                    component: () =>
                      import(
                        /* webpackChunkName: "User" */ "@/views/censThreePage/logoDetail/management/User"
                      ),
                    meta: {
                      auth: true,
                      per: "User",
                    },
                  },
                  {
                    path: "Role",
                    name: "Role",
                    component: () =>
                      import(
                        /* webpackChunkName: "Role" */ "@/views/censThreePage/logoDetail/management/Role"
                      ),
                    meta: {
                      auth: true,
                      per: "Role",
                    },
                  },
                  {
                    path: "Backstage",
                    name: "Backstage",
                    component: () =>
                      import(
                        /* webpackChunkName: "Backstage" */ "@/views/censThreePage/logoDetail/management/Backstage"
                      ),
                    meta: {
                      auth: true,
                      per: "Backstage",
                    },
                    children: [
                      {
                        path: "Enterprise",
                        name: "Enterprise",
                        component: () =>
                          import(
                            /* webpackChunkName: "Enterprise" */ "@/views/censThreePage/logoDetail/management/components/CompanyTable"
                          ),
                      },
                      {
                        path: "NewsInformation",
                        name: "NewsInformation",
                        component: () =>
                          import(
                            /* webpackChunkName: "NewsInformation" */ "@/views/censThreePage/logoDetail/management/components/NewsTable"
                          ),
                      },
                      {
                        path: "GroupInformation",
                        name: "GroupInformation",
                        component: () =>
                          import(
                            /* webpackChunkName: "GroupInformation" */ "@/views/censThreePage/logoDetail/management/components/GroupTable"
                          ),
                      },
                    ],
                  },
                  // { 
                  //   path: "Analysis",
                  //   name: "Analysis",
                  //   component: () => import(/* webpackChunkName: "Analysis" */ "@/views/censThreePage/logoDetail/management/Analysis")
                  // },
                  {
                    path: "BrandCensus",
                    name: "BrandCensus",
                    component: () => import(/* webpackChunkName: "BrandCensus" */ "@/views/censThreePage/logoDetail/components/BrandCensus")
                  },
                  {
                    path: "NewsCensus",
                    name: "NewsCensus",
                    component: () => import(/* webpackChunkName: "BrandCensus" */ "@/views/censThreePage/logoDetail/components/NewsCensus")
                  },
                  
                ],
              },
            ],
          }, 
          {
            path: "Home",
            name: "Home",
            component: () =>
              import(
                /* webpackChunkName: "CompanyIntroduction" */ "@/views/censThreePage/logoDetail/components/homePage"
              ),
          },
          {
            path: "FeelingDetail",
            name: "FeelingDetail",
            component: () => import(/* webpackChunkName: "FeelingDetail" */ "@/views/censThreePage/logoDetail/components/census/FeelingDetail"),
            meta: {
              parentName: "BrandCensus"
            }
          },
          {
            path: "MediaDetail",
            name: "MediaDetail",
            component: () => import(/* webpackChunkName: "MediaDetail" */ "@/views/censThreePage/logoDetail/components/census/MediaDetail"),
            meta: {
              parentName: "BrandCensus"
            }
          }
        ],
      },
    ],
  },
];

export default v3Router;
